/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DataStructureTreeIcon16Light } from './DataStructureTreeIcon16Light';
import { DataStructureTreeIcon16Regular } from './DataStructureTreeIcon16Regular';
import { DataStructureTreeIcon16Solid } from './DataStructureTreeIcon16Solid';
import { DataStructureTreeIcon20Light } from './DataStructureTreeIcon20Light';
import { DataStructureTreeIcon20Regular } from './DataStructureTreeIcon20Regular';
import { DataStructureTreeIcon20Solid } from './DataStructureTreeIcon20Solid';
import { DataStructureTreeIcon24Regular } from './DataStructureTreeIcon24Regular';
import { DataStructureTreeIcon24Solid } from './DataStructureTreeIcon24Solid';
import { DataStructureTreeIcon32Regular } from './DataStructureTreeIcon32Regular';
import { DataStructureTreeIcon64Regular } from './DataStructureTreeIcon64Regular';
var sizes = {
    16: {
        light: DataStructureTreeIcon16Light,
        regular: DataStructureTreeIcon16Regular,
        solid: DataStructureTreeIcon16Solid,
    },
    20: {
        light: DataStructureTreeIcon20Light,
        regular: DataStructureTreeIcon20Regular,
        solid: DataStructureTreeIcon20Solid,
    },
    24: {
        regular: DataStructureTreeIcon24Regular,
        solid: DataStructureTreeIcon24Solid,
    },
    32: {
        regular: DataStructureTreeIcon32Regular,
    },
    64: {
        regular: DataStructureTreeIcon64Regular,
    },
};
export var DataStructureTreeIcon = forwardRef('DataStructureTreeIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
